<template>
	<!-- 日志 -->
	<div class="activityHistory_main" :class="{'cn':version == '1'}">
		<div class="activityHistory_left">
			<!-- <side-bar></side-bar> -->
		</div>
		<div class="activityHistory_right">
			<div class="activityHistory_right_top">
				<div class="right_top_l">
					<el-select v-model="userId">
                        <el-option :key="0" label="All" :value="0"></el-option>
						<el-option
							v-for="item in userNav"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<el-input :placeholder="$t('App.placeholder.text2')" v-model="keywords" @keyup.native="getLogListKeyUp($event)" class="input-with-select">
						<i slot="suffix" class="el-input__icon el-icon-search" @click="getLogList()"></i>
					</el-input>
				</div>
			</div>
			<div class="activityHistory_right_main">
				<div class="main_top">
					<div class="main_top_l">
						<div class="div1"><span>{{$t('App.activityHistory.text1')}}</span></div>
						<div class="div2">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
							<div class="btn" @click="postDelLog(checkList,'batch')">
								<i class="iconfont icon-delete"></i>
								<span>{{$t('App.lights.text1')}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="main_cont">
					<el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
							<!-- element-loading-background="rgba(0, 0, 0, 0.5)" -->
						<el-table
							ref="logDataList"
							v-loading="loading.logDataList"
							height="100%"
							:data="logDataList">
							<el-table-column
								:label="$t('App.lights.text33')"
								header-align="center"
								:prop="'index'"
								align="left"
								:width="100">
								<template slot-scope="scope">
									<el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
								</template>
							</el-table-column>
							<el-table-column
								v-for="(item) in logArr"
								:key="'table_'+item.prop"
								:prop="item.prop"
								:label="item.label"
								:align="item.align?item.align:'center'"
								:width="item.width"
								:show-overflow-tooltip="true"
								:min-width="item.minWidth">
									<template slot-scope="scope">
										<span v-if="item.type != 1">{{scope.row[item.prop]}}</span>
										<!-- <div v-if="item.prop == 'activites'" class="activites">
											<span :class="'text_'+scope.row[item.prop]">{{activitesArr[scope.row[item.prop]]}}</span>
										</div> -->
									</template>
								</el-table-column>
								<el-table-column
								align="center"
								:min-width="100"
								:label="$t('App.lights.text6')">
								<template slot-scope="scope">
									<span class="btn" @click="postDelLog(scope.row,'')" :title="$t('App.lights.text1')">
										<i class="iconfont icon-delete"></i>
									</span>
								</template>
							</el-table-column>
						</el-table>
					</el-checkbox-group>
					<div class="pagination_box">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-size="pageSize"
							layout="prev, pager, next"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	// import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
	export default {
		name:'activityHistory',
		data () {
			return{
				userId:'',
				userNav:[],
				keywords:'',

				checkAll:false,
				isIndeterminate:false,
				checkList:[],

				logArr:[],
				logDataList:[],
				logDataIdList:[],
				// activitesArr:['New equipment','Editing equipment','Delete device','modify state'],

				currentPage:1,
				pageSize:20,
				total:0,

				loading:{
					logDataList:false,
				}
			}
		},
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
        },
		components:{
			// 'sideBar':sideBar
		},
		mounted(){
            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            this.logArr = [
                {prop:'name',label:this.$t('App.activityHistory.text2'),minWidth:70},
                {prop:'activites',label:this.$t('App.activityHistory.text3'),minWidth:100},
                {prop:'floor',label:this.$t('App.floor'),minWidth:60},
                {prop:'room',label:this.$t('App.room.text1'),minWidth:60},
                {prop:'time',label:this.$t('App.activityHistory.text4'),width:200},
                {prop:'description',label:this.$t('App.activityHistory.text5'),minWidth:200,align:'left'},
            ];
            this.getUserNav(()=>{
                this.userId = 0
				// if(this.userNav.length > 0){
				// 	this.userId = this.userNav[0].id;
				// }
				this.getLogList();
			});
		},
		methods:{
            /*用户下拉列表*/
            getUserNav(callback){
                base.ajax_post(
                    allUrl.userManagement.userNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.userNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*获取日志信息列表*/
            getLogListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getLogList();
                }
            },
            getLogList(callback){
                this.loading.logDataList = true;
                base.ajax_post(
                    allUrl.activityHistory.logList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        userId:this.userId,
                        page:this.currentPage,
                        count:this.pageSize,
                        keywords:this.keywords,
                    },
                    {},
                    data=>{
                        this.loading.logDataList = false;
                        this.logDataList = data.data.list;
                        this.total = Number(data.data.total);

                        this.logDataIdList = [];
                        this.checkList = [];
                        this.isIndeterminate = false;
                        this.checkAll = false;
                        for(let d of this.logDataList){
                            this.logDataIdList.push(d.id);
                        }
                        let i = 1 + (this.currentPage-1)*this.pageSize;
                        for(let d of this.logDataList){
                            d.webIndex = i;
                            i++;
                        }
                        if(callback){
                            callback(data)
                        }
                    },
                    this,()=>{
                        this.loading.logDataList = false;
                    }
                )
            },
            /*删除日志*/
            postDelLog(obj,type){
                let logId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text23'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(logId == ''){
                                logId = id;
                            }else{
                                logId += ','+id;
                            }
                        }
                    }
                }else{
                    logId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text3'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.activityHistory.delLog,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                logId:logId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getLogList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
			/*分页*/
			handleSizeChange(val) {
				this.pageSize = val;
				this.getLogList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getLogList();
				// console.log(val)
			},
			handleCheckAllChange(val) {
				console.log(val)
				this.checkList = val ? this.logDataIdList : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value){
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.logDataIdList.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.logDataIdList.length;
			},
		},
        watch:{
            userId:function(){
				this.getLogList();
            }
        }
	}
</script>

<style type="text/css" lang="less">
    .activityHistory_main{
		width: 100%;
		height: 100%;
		// height: 105rem;
		min-height: 50rem;
		// min-width: 120rem;
		margin: 0 auto;
		overflow: hidden;
		position: relative;
		display: flex;
		background: #F6F8FA;
        &.cn{
            .activityHistory_right{
                .activityHistory_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .activityHistory_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
        }
		.activityHistory_left{
			width: 11.67rem;
			height: 100%;
            min-width: 130px;
		}
        .activityHistory_right{
			position: relative;
			padding: 1.92rem 1.5rem 0;
			width: calc(100% - 11.67rem);
			height: calc(100%);
			.activityHistory_right_top{
				display: flex;
				justify-content: space-between;
				.right_top_l{
					.el-input__inner{
						height: 2.5rem;line-height: 2.5rem;
						border-radius: 1.25rem;
						font-family: AlibabaPuHuiTiR;
						font-size: 1rem;
						color: #333333;
						border-color: #F0F0F0;
					}
					.el-input__icon{
						height: 2.5rem;line-height: 2.5rem;
					}
					.el-select{
						width: 11.42rem;
					}
					>.el-input{
						margin-left: 1rem;
						width: 19rem;
						.el-icon-search{
                            display: inline-block;
							top: 0;bottom: 0;
							right: 0;
							width: 4rem;
							background: #05CFAB;
							border-radius: 1.25rem;
							cursor: pointer;
							color: #FFFFFF;
						}
                        .el-input__suffix{
                            right: 0;
                        }
					}
				}
			}
			.activityHistory_right_main{
				height: calc(100% - 6.5rem);
				margin-top: 1rem;
				position: relative;
				background: #FFFFFF;
				border: 1px solid #F0F0F0;
				border-radius: 0.4rem;
				.main_top{
					width: 100%;
					display: flex;
					justify-content: space-between;
					padding: 0 1.67rem 0;
					.main_top_l{
						.div1{
							margin-top: 1.5rem;
							font-family: AlibabaPuHuiTiB;
							font-size: 1.5rem;
							color: #333333;
						}
						.div2{
							margin-top: 1.33rem;
							display: flex;
							.btn{
								margin-left: 1.29rem;
								display: flex;align-items: center;
								font-family: AlibabaPuHuiTiR;
								font-size: 1rem;
								color: #333333;
								cursor: pointer;
								i{
									font-size:0.8rem;
									color: #C6CDD5;
								}
								span{
									margin-left: 0.5rem;
								}
							}
						}
					}
					// .main_top_r{
					// 	margin-top: 2.33rem;
					// 	display: flex;
					// 	.btn{
					// 		margin-left: 1rem;
					// 		height: 2.5rem;line-height: 2.5rem;
					// 		padding: 0 1.25rem;
					// 		background: #FFFFFF;
					// 		border: 1px solid #F0F0F0;
					// 		border-radius: 1.25rem;
					// 		font-family: PingFang-SC-Medium;
					// 		font-size: 1rem;
					// 		color: #333333;
					// 		cursor: pointer;
					// 		display: flex;
					// 		align-items: center;
					// 		img{
					// 			margin-right: 0.5rem;
					// 			height: 1rem;
					// 		}
					// 	}
					// }
				}
				.main_cont{
					height: calc(100% - 11rem);
					margin-top: 0.75rem;
					.el-checkbox-group{
						height: 100%;
					}
					.el-table{
						.el-checkbox{
							margin-left: 1.1rem;
						}
						.btn{
							padding: 0.5rem;
							cursor: pointer;
							&+.btn{
								margin-left: 0.2rem;
							}
							i{
								color: #A3AFBB;
								font-size:0.8rem;
							}
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
						}
						th{
							font-weight:initial;
							height: 3rem;
							border-top: 1px solid #F0F0F0;
							border-bottom: 1px solid #F0F0F0;
							padding: 0;
							background: #F6F8FA;
							&>.cell{
								font-family: AlibabaPuHuiTiR;
								font-size: 1rem;
								color: #333333;
							}
						}
						td{
							padding: 0;
							height: 3rem;
							&>.cell,.el-checkbox__label{
								font-family: AlibabaPuHuiTiR;
								font-size: 1rem;
								color: #657085;
							}
						}
						.activites{
							.text_0{
								color: #05CFAB;
							}
							.text_1{
								color: #0A82CF;
							}
							.text_2{
								color: #FF0C4D;
							}
							.text_3{
								color: #0A82CF;
							}
						}
					}
					.pagination_box{
						.el-pagination{
							float: right;
							margin-top: 0.5rem;
						}
						height: 2.5rem;line-height: 2.5rem;
						.btn-prev .el-icon{
							font-size:1rem;
							color: #666666;
							font-family: PingFang-SC-Medium;
						}
						button{
							width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
							padding: 0;
							background: #F6F8FA;
							border-radius: 0.2rem;
						}
						.el-pager li{
							margin-left: 0.83rem;
							width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
							padding: 0;
							background: #F6F8FA;
							border-radius: 0.2rem;
							&:hover{
								color: rgba(5,207,171,1);
								background-color: rgba(5,207,171,0.1);
							}
						}
						.btn-next{
							margin-left: 0.83rem;
						}
						.el-pager li.active{
							background: #05CFAB;
							color: #FFFFFF;
						}
					}
				}
			}
        }
    }
</style>